module.exports = __webpack_public_path__ + "img/docs.c41b265e.svg";